<template>
  <div class="text-center flex flex-col gap-8 items-center">
    <div class="flex flex-col gap-1">
      <PageHeaderTitle>
        {{ props.title }}
      </PageHeaderTitle>

      <PageHeaderDescription>
        {{ props.description }}
      </PageHeaderDescription>

      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PageHeaderDescription } from "@authentication/ui/atoms/PageHeaderDescription";
import { PageHeaderTitle } from "@authentication/ui/atoms/PageHeaderTitle";

// Props
const props = defineProps({
  description: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
});
</script>
